// extracted by mini-css-extract-plugin
module.exports = {"vehicleOriginalPrice":"VehicleOriginalPrice_vehicleOriginalPrice___Wl7N"};